import { render } from "./ModalAuditoria.vue?vue&type=template&id=1354c4f1&scoped=true"
import script from "./ModalAuditoria.vue?vue&type=script&lang=js"
export * from "./ModalAuditoria.vue?vue&type=script&lang=js"

import "./ModalAuditoria.vue?vue&type=style&index=0&id=1354c4f1&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1354c4f1"]])

export default __exports__